import NextImage from '@allesauto/core/nextImage';
import { FieldTypeAsset } from '@allesauto/utils/storyblok';
import { sbEditable } from '@storyblok/storyblok-editable';
import React, { FC } from 'react';

import VehicleSearchForm, {
  VehicleSearchFormProps,
} from '../QuickEntryWidget/VehicleSearchForm/VehicleSearchForm';

export interface CarFinderProps {
  image: FieldTypeAsset;
  headline: string;
  vehicleSearchForm?: VehicleSearchFormProps;
  customButtonName?: string;
  mobileImageIsSquare?: boolean;
  component: string;
  _uid: string;
  _editable?: string;
}

const CarFinder: FC<React.PropsWithChildren<CarFinderProps>> = (props) => {
  const {
    image,
    headline,
    vehicleSearchForm,
    customButtonName,
    mobileImageIsSquare = true,
  } = props;

  const shouldRenderVehicleSearchForm = !!vehicleSearchForm?.facets;
  const className = {
    container:
      'grid grid-cols-24 h-auto max-w-screen-xl pb-30px pt-40px w-full bg-purple80 monochrome:bg-grey20',
    introContainer:
      'col-end-24 col-span-full col-start-2 mt-30px md:col-span-9 md:col-start-2 md:mt-60px',
    headline:
      'font-headline text-headline2 text-white monochrome:text-black mb-40px',
    imageContainer: 'block pointer-events-none relative mb-40px',
    inputsContainer:
      'col-end-24 col-span-full col-start-2 flex flex-col mb-10px md:col-span-11 md:col-start-13 md:mb-[70px] md:mt-60px',
    image: `w-full h-full ${
      mobileImageIsSquare ? 'sm:aspect-square lg:aspect-[2/1]' : 'aspect-[2/1]'
    }`,
  };

  return (
    <div {...sbEditable(props)} className={className.container}>
      <div className={className.introContainer}>
        <div className={className.headline}>{headline}</div>
        <div className={className.imageContainer}>
          {image.filename && (
            <NextImage
              useCustomLoader={false}
              alt={image.alt}
              src={image.filename}
              className={className.image}
              layout="fill"
              objectFit="cover"
            />
          )}
        </div>
      </div>
      {shouldRenderVehicleSearchForm && (
        <div className={className.inputsContainer}>
          <VehicleSearchForm
            {...vehicleSearchForm}
            darkBg={true}
            hasExtraLinks={false}
            customButtonName={customButtonName}
          />
        </div>
      )}
    </div>
  );
};

export default CarFinder;
